'use client';

import { useEffect } from 'react';

/**
 * Регистрация сервис-воркера.
 *
 * Отдельный клиентский компонент, потому что лейаут остаётся серверным:
 * пометив 'use client' весь лейаут, мы потеряли бы статическую генерацию
 * страниц. Здесь же нет разметки, только эффект.
 *
 * Регистрацию раньше делал `next-pwa` вставкой скрипта в страницу. Плагин
 * на Turbopack не запускался, поэтому не было ни воркера, ни его вызова:
 * PWA ставилась ярлыком, но офлайн не работал и статика ходила в сеть
 * каждый раз.
 *
 * Область `/` задаётся явно вместе с заголовком `Service-Worker-Allowed`
 * на самом файле: без этой пары воркер управлял бы только своим каталогом.
 */
export function ServiceWorker() {
  useEffect(() => {
    // В разработке воркер только мешает: он отдаёт из кэша страницу,
    // собранную до правки, и изменения не видно без ручной очистки.
    if (process.env.NODE_ENV !== 'production') return;

    // Нет поддержки или небезопасный контекст: по обычному HTTP на
    // постороннем имени хоста API недоступен, и обращение к нему упало бы.
    if (!('serviceWorker' in navigator)) return;

    // Регистрация не блокирует отрисовку и намеренно тихая: неудача здесь
    // не должна ломать страницу, сайт работает и без офлайн-кэша.
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => undefined);

    // Проверить заранее сохранённые страницы: воркер перекачает только те,
    // что старше срока (sw.js, SROK_KOPII_MS). Без этой просьбы прогрев шёл
    // лишь при установке новой версии воркера, и копии не обновлялись.
    void navigator.serviceWorker.ready
      .then((registration) => {
        registration.active?.postMessage({ type: 'warm' });
      })
      .catch(() => undefined);
  }, []);

  return null;
}
